export default __webpack_public_path__ + "static/media/img-avatar.17de7ea5.png";